import React, { useState } from "react";
import logo from "./assets/Admify_Logo.png";
import { Menu, X } from "lucide-react"; // Iconos de menú


export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="container flex justify-between items-center py-4">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <img src={logo} alt="Admify Logo" className="h-10 object-contain" />
          <h1 className="text-xl font-semibold text-[var(--color-dark)]">
            Admify - Soluciones Integrales
          </h1>
        </div>

        {/* Botón menú hamburguesa (solo en móviles) */}
        <button
          className="md:hidden text-[var(--color-dark)] focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Menú principal (desktop) */}
        <nav className="hidden md:flex space-x-6">
          <a href="#inicio" className="hover:text-[var(--color-accent)] transition-colors">Inicio</a>
          <a href="#servicios" className="hover:text-[var(--color-accent)] transition-colors">Servicios</a>
          <a href="#nosotros" className="hover:text-[var(--color-accent)] transition-colors">Acerca de Admify</a>
          <a href="#contacto" className="hover:text-[var(--color-accent)] transition-colors">Contacto</a>
        </nav>
      </div>

      {/* Menú desplegable en móviles */}
      {menuOpen && (
        <nav className="md:hidden bg-white border-t border-gray-200">
          <div className="flex flex-col items-center py-4 space-y-4">
            <a href="#inicio" className="hover:text-[var(--color-accent)]" onClick={() => setMenuOpen(false)}>Inicio</a>
            <a href="#servicios" className="hover:text-[var(--color-accent)]" onClick={() => setMenuOpen(false)}>Servicios</a>
            <a href="#nosotros" className="hover:text-[var(--color-accent)]" onClick={() => setMenuOpen(false)}>Nosotros</a>
            <a href="#contacto" className="hover:text-[var(--color-accent)]" onClick={() => setMenuOpen(false)}>Contacto</a>
          </div>
        </nav>
      )}
    </header>
  );
};


